/**
 * delay - Prevents an execution of a promise by a specified timeout time.
 *
 * @param {number} timeout A number of milliseconds to wait before resolving
 * the promise returned from `delay`.
 *
 * @return {Promise} A promise than will be resolved after specified timeout.
 */
export const delay = timeout =>
  // eslint-disable-next-line no-promise-executor-return
  new Promise(resolve => setTimeout(resolve, timeout));
